import React from 'react';
import { withRouter } from 'react-router-dom';

import PropTypes from 'prop-types';
import Header from './header/header';
import LeftNav from './leftnav';

import { publicRoutes } from '../config/routes';

import IdleTimer from 'react-idle-timer';

import { logout, updateMaxAge, expirySet, isLoggedIn } from '../auth';
import { preformatWithRequestID } from '../helpers';

import SharedSnackbar from '../components/common/sharedsnackbar';

import AppStore from '../stores/app-store';
import AppActions from '../actions/app-actions';
import AppConstants from '../constants/app-constants';
import { AppContext } from '../contexts/app-context';
import { getOnboardingComponentFor } from '../utils/onboardingmanager';
import CreateArtifactDialog from './common/dialogs/createartifactdialog';
import ConfirmDismissHelptips from './common/dialogs/confirmdismisshelptips';
import DeviceConnectionDialog from './common/dialogs/deviceconnectiondialog';

var isDemoMode = false;
var _HostedAnnouncement = '';

class AppRoot extends React.Component {
  static childContextTypes = {
    muiTheme: PropTypes.object,
    router: PropTypes.object,
    location: PropTypes.object
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      redirect: {},
      artifactProgress: 0,
      aiArtifactProgress: 0,
      version: AppStore.getMenderVersion(),
      docsVersion: AppStore.getDocsVersion(),
      timeout: 900000, // 15 minutes idle time,
      uploadArtifact: (meta, file) => this._uploadArtifact(meta, file),
      uploadAiArtifact: (meta, file) => this._uploadAiArtifact(meta, file),
      updateRedirect: (redirect) => this._updateRedirect(redirect),
      ...this._getState()
    };

    /** Bind methods to avoid method re-creation */
    this._onChangeBind = this._onChange.bind(this);
    this._updateRedirectBind = this._updateRedirect.bind(this);
  }

  getChildContext() {
    return {
      location: this.props.location
    };
  }

  _getState() {
    return {
      currentUser: AppStore.getCurrentUser(),
      uploadInProgress: AppStore.getUploadInProgress(),
      globalSettings: AppStore.getGlobalSettings(),
      snackbar: AppStore.getSnackbar(),
      showDismissHelptipsDialog: !AppStore.getOnboardingComplete() && AppStore.getShowOnboardingTipsDialog(),
      showCreateArtifactDialog: AppStore.getShowCreateArtifactDialog(),
      showDeviceConnectionDialog: AppStore.getShowConnectDeviceDialog()
    };
  }

  UNSAFE_componentWillMount() {
    AppStore.changeListener(this._onChangeBind);
  }
  componentDidMount() {
    window.addEventListener('mousemove', updateMaxAge, false);
  }
  componentWillUnmount() {
    window.addEventListener('mousemove', updateMaxAge, false);
    AppStore.removeChangeListener(this._onChangeBind);
  }
  _onChange(type) {
    if (type !== AppConstants.SET_PENDING_DEVICES &&
        type !== AppConstants.SET_PREAUTHORIZED_DEVICES &&
        type !== AppConstants.SET_REJECTED_DEVICES &&
        type !== AppConstants.RECEIVE_GROUPS &&
        type !== AppConstants.SET_ACCEPTED_DEVICES &&
        type !== AppConstants.RECEIVE_ALL_DEVICES &&
        type !== AppConstants.SET_REJECTED_DEVICES_COUNT &&
        type !== AppConstants.SET_PENDING_DEVICES_COUNT &&
        type !== AppConstants.SET_ACCEPTED_DEVICES_COUNT &&
        type !== AppConstants.SET_PREAUTH_DEVICES_COUNT &&
        type !== AppConstants.SET_DEVICE_LIMIT) {
      this.setState(this._getState());
    }
  }
  _onIdle() {
    if (expirySet() && this.state.currentUser) {
      // logout user and warn
      if (!this.state.uploadInProgress) {
        logout();
        AppActions.setSnackbar('Your session has expired. You have been automatically logged out due to inactivity.');
        return;
      }
      updateMaxAge();
    }
  }

  _uploadArtifact(meta, file) {
    var self = this;
    var progress = percent => self.setState({ artifactProgress: percent });
    AppActions.setSnackbar('Uploading artifact');
    return new Promise((resolve, reject) =>
      AppActions.uploadArtifact(meta, file, progress)
        .then(() => AppActions.setSnackbar('Upload successful', 5000))
        .catch(err => {
          try {
            var errMsg = err.res.body.error || '';
            AppActions.setSnackbar(preformatWithRequestID(err.res, `Artifact couldn't be uploaded. ${errMsg}`), null, 'Copy to clipboard');
          } catch (e) {
            console.log(e);
          }
          reject();
        })
        .finally(() => {
          self.setState({ artifactProgress: 0 });
          resolve();
        })
    );
  }

  _uploadAiArtifact(meta, file) {
    var self = this;
    var progress = percent => self.setState({ aiArtifactProgress: percent });
    AppActions.setSnackbar('Uploading artifact');
    return new Promise((resolve, reject) =>
      AppActions.uploadAiArtifact(meta, file, progress)
        .then(() => AppActions.setSnackbar('Upload successful', 5000))
        .catch(err => {
          try {
            var errMsg = err.res.body.error || '';
            AppActions.setSnackbar(preformatWithRequestID(err.res, `Artifact couldn't be uploaded. ${errMsg}`), null, 'Copy to clipboard');
          } catch (e) {
            console.log(e);
          }
          reject();
        })
        .finally(() => {
          self.setState({ aiArtifactProgress: 0 });
          resolve();
        })
    );
  }

  _updateRedirect(redirect) {
    this.setState({redirect});
  }

  render() {
    const { snackbar, timeout, showDismissHelptipsDialog, showDeviceConnectionDialog, showCreateArtifactDialog, ...context } = this.state;

    const onboardingComponent = getOnboardingComponentFor('application-update-reminder-tip', {
      anchor: {
        left: 170,
        top: 225
      },
      place: 'right'
    });

    return (
      <>
      {
        isLoggedIn()
          ?
          (
            <IdleTimer element={document} idleAction={this._onIdle} timeout={timeout} format="MM-DD-YYYY HH:MM:ss.SSS">
              <Header
                className="header"
                announcement={_HostedAnnouncement}
                docsVersion={context.docsVersion}
                demo={isDemoMode}
                history={this.props.history}
                isLoggedIn={true}
              />

              <div className="wrapper">
                <LeftNav
                  version={context.version}
                  className="leftFixed leftNav"
                  docsVersion={context.docsVersion}
                  updateRedirect={this._updateRedirectBind} />
                <div className="rightFluid container">
                  <AppContext.Provider value={context}>{this.props.children}</AppContext.Provider>
                </div>
              </div>
              {onboardingComponent ? onboardingComponent : null}
              <ConfirmDismissHelptips open={showDismissHelptipsDialog} />
              <CreateArtifactDialog open={showCreateArtifactDialog} onCancel={() => AppActions.setShowCreateArtifactDialog(false)} />
              <DeviceConnectionDialog open={showDeviceConnectionDialog} onCancel={() => AppActions.setShowConnectingDialog(false)} />
            </IdleTimer>
          )
          :
          (publicRoutes())
      }
        <SharedSnackbar snackbar={snackbar} />
      </>
    );
  }
}
const App = withRouter(AppRoot);
export default App;
